import type { FC } from 'react';

import { useCustomerSelector } from '@jane/monolith/customer/redux';
import type { ModalNames } from '@jane/monolith/customer/redux/modal';
import { selectModal } from '@jane/monolith/customer/redux/modal';

import { CartAlerts } from './cartAlerts';
import { LoginModal } from './loginModal';
import { Logout } from './logout';
import { ReplaceCart } from './replaceCart';

const MODALS: Record<ModalNames, FC> = {
  cartAlerts: CartAlerts,
  login: LoginModal,
  logout: Logout,
  replaceCart: ReplaceCart,
};

export const Modals = () => {
  const { modalName } = useCustomerSelector(selectModal);

  if (modalName) {
    const CurrentModal = MODALS[modalName];
    if (!CurrentModal) throw new Error(`Cannot find modal: ${modalName}`);
    return <CurrentModal />;
  }

  return null;
};
